import { sectionOpen } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** header — contentless shell; site-level navigation is rendered by render.ts. */
export function renderHeader(section: PatternSectionT): string {
  return [sectionOpen(section), '  <div class="ve-header__shell" aria-hidden="true"></div>', '</section>'].join('\n');
}
